import React from 'react'
import { ApplicationFlowTheme, DownloadSkinViewModel } from '../types'
import DownloadSkin from './download-skin'

interface Props {

  /** 旧注册成功页映射出的展示数据。 */
  model: DownloadSkinViewModel

  /** 渠道模板唯一确定的主题。 */
  theme: ApplicationFlowTheme

  /** 返回意图，交由旧容器决定路由语义。 */
  onBack?: () => void

  /** 下载意图，最终由旧页面完成下载和上报。 */
  onDownload: () => void

  /** 关闭微信提示意图，最终由旧页面更新本地状态。 */
  onCloseWechatTip: () => void
}

/**
 * DownloadSkinContainer — 连接注册成功旧容器与纯展示下载皮肤，不处理业务副作用。
 * @returns {React.ReactElement} 下载皮肤节点
 */
const DownloadSkinContainer: React.FC<Props> = React.memo(({ model, onBack, onCloseWechatTip, onDownload, theme }) => (
  <DownloadSkin model={model} onBack={onBack} onCloseWechatTip={onCloseWechatTip} onDownload={onDownload} theme={theme} />
))

DownloadSkinContainer.displayName = 'DownloadSkinContainer'

export default DownloadSkinContainer
